import { Component } from 'react';
import Styles from "./styles.module.scss";
import Button from '../../compopnents/button';
import ellowLogo from "../../assets/images/ellow-logo.png";
import alerticon from "../../assets/images/alert-circle.svg";

interface ErrorBoundaryProps {}

interface ErrorBoundaryState {
  hasError: boolean;
}


const onClick = () =>{
  window.location.reload();
}
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState>  {

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
      <section className={Styles.errorWrap}>
      <img src={ellowLogo} alt="Ellow" className={Styles.logo} />
      <div className={Styles.errorMessage}>
        <img src={alerticon} className={Styles.errorIcon} alt=''/>
        <h1>Oops...!</h1>
        <p>Something went wrong...</p>
        <Button variant="secondary" onClick={onClick}>Try again</Button>
      </div>
    </section>
    )}

    return this.props.children; 
  }




  
  // return (

 

  // )
}

export default ErrorBoundary